import type {CSSProperties} from 'react';
import {WEDGE_SHELL as B} from '@territory/tokens';
import {control, font, radius, space, TOUCH_MIN, weight} from '../scale.js';

export type WedgeEmailOptions =
  | {look: 'send'; state?: 'sending'}
  | {look: 'resend'; state?: 'cooldown'}
  | {look: 'typo' | 'domain' | 'change-address'; state?: never};
const CHIP_PX = 14;
const SEND_PY = 15;
const SEND_GAP = 10;
const SMALL_FONT = 12.5;

export function wedgeEmailStyle(options?: WedgeEmailOptions): CSSProperties {
  const base: CSSProperties = {background: 'none', border: 0, cursor: 'pointer', fontFamily: 'inherit'};
  if (options?.look === 'typo' || options?.look === 'domain') return {
    ...base, background: options.look === 'typo' ? B.warningControlSurface : B.domainSurface,
    border: options.look === 'typo' ? 0 : `1px solid ${B.border}`,
    color: options.look === 'typo' ? B.warningControlInk : B.text,
    padding: `0 ${CHIP_PX}px`, borderRadius: radius.pill, fontSize: font.caption,
    fontWeight: options.look === 'typo' ? weight.bold : weight.semibold, minHeight: TOUCH_MIN,
  };
  if (options?.look === 'resend') {
    const cooldown = options.state === 'cooldown';
    return {...base, background: cooldown ? 'transparent' : B.resendSurface,
      border: `1px solid ${cooldown ? B.resendMutedBorder : B.resendBorder}`,
      color: cooldown ? B.textSec : B.accent, fontSize: SMALL_FONT, fontWeight: weight.bold,
      cursor: cooldown ? 'not-allowed' : 'pointer', padding: `0 ${CHIP_PX}px`, borderRadius: radius.pill, minHeight: TOUCH_MIN};
  }
  if (options?.look === 'change-address') return {...base, color: B.emailChangeInk, fontSize: SMALL_FONT,
    fontWeight: weight.semibold, padding: `0 ${space[1]}px`, minHeight: TOUCH_MIN, textDecoration: 'underline', textUnderlineOffset: 3};
  const sending = options?.look === 'send' && options.state === 'sending';
  return {...base, width: '100%', padding: `${SEND_PY}px ${space[5]}px`, borderRadius: radius.xl,
    border: `1px solid ${B.borderStrong}`, background: B.surfaceStrong, color: B.accent,
    fontSize: font.callout, fontWeight: weight.bold, cursor: sending ? 'wait' : 'pointer', opacity: sending ? 0.75 : 1,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: SEND_GAP, minHeight: control.field};
}
const root = '[data-rv-button][data-rv-appearance="wedge-email"]';
export const WEDGE_EMAIL_BUTTON_CSS = `
${root}[data-rv-email-look="send"]:hover:not(:disabled) { background: ${B.glassHover} !important; border-color: ${B.glassHoverBorder} !important; transform: translateY(-1px); }
${root}[data-rv-email-look="domain"]:hover { background: ${B.domainHoverSurface} !important; border-color: ${B.domainHoverBorder} !important; }
`;
